import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-email',
  templateUrl: './text-email.component.html',
  styleUrls: ['./text-email.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
